"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var Metadata_module_css_1 = __importDefault(require("./Metadata.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var MetadataModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, modalMode = _a.modalMode, existingMetadata = _a.existingMetadata;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)(false), isDuplicate = _b[0], setIsDuplicate = _b[1];
    var _c = (0, react_1.useState)(false), isTooLong = _c[0], setIsTooLong = _c[1];
    var _d = (0, react_1.useState)([]), allMetadataKeys = _d[0], setAllMetadataKeys = _d[1];
    var _e = (0, react_1.useState)(existingMetadata ? existingMetadata.meta_key : ""), metaKey = _e[0], setMetaKey = _e[1];
    var _f = (0, react_1.useState)(existingMetadata ? existingMetadata.description : ""), description = _f[0], setDescription = _f[1];
    var _g = (0, react_1.useState)(function () {
        if (existingMetadata) {
            try {
                var parsedKeyValuePairs = typeof existingMetadata.key_value_pairs === "string"
                    ? JSON.parse(existingMetadata.key_value_pairs)
                    : existingMetadata.key_value_pairs;
                return Object.entries(parsedKeyValuePairs).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return ({
                        key: key,
                        value: value,
                        isExisting: true,
                        isUsed: false,
                    });
                });
            }
            catch (error) {
                logger.error("Error processing existing key-value pairs:", error);
                return [{ key: "", value: "", isUsed: true }];
            }
        }
        return [{ key: "", value: "", isUsed: false }];
    }), keyValuePairs = _g[0], setKeyValuePairs = _g[1];
    var checkForDuplicateMetaKey = function (newMetaKey) {
        if (newMetaKey === "") {
            setIsDuplicate(false);
            return;
        }
        var duplicate = allMetadataKeys.includes(newMetaKey);
        setIsDuplicate(duplicate);
    };
    var debouncer = (0, react_1.useMemo)(function () { return new q_play_core_1.Debouncer(checkForDuplicateMetaKey, 300); }, [allMetadataKeys]);
    var handleMetaKeyChange = function (event) {
        var newMetaKey = event.target.value;
        setMetaKey(newMetaKey);
        if (modalMode === "new") {
            debouncer.debounce(newMetaKey.trim());
        }
    };
    var handleDescriptionChange = function (event) {
        var value = event.target.value;
        setDescription(value);
        setIsTooLong(value.length > 250);
    };
    var isInvalidKeyPairFunction = function (pair) {
        return pair.key.trim() === "" && pair.value.trim() !== "" && !(modalMode === "edit" && pair.isExisting);
    };
    var isInvalidKeyPair = keyValuePairs.some(isInvalidKeyPairFunction);
    var handleKeyValuePairsChange = function (index, key, value) {
        var newKeyValuePairs = __spreadArray([], keyValuePairs, true);
        newKeyValuePairs[index] = __assign(__assign({}, newKeyValuePairs[index]), { key: key, value: value.trim() });
        setKeyValuePairs(newKeyValuePairs);
    };
    var addKeyValuePair = function () {
        return setKeyValuePairs(__spreadArray(__spreadArray([], keyValuePairs, true), [
            { key: "", value: "", isExisting: false, isUsed: false },
        ], false));
    };
    var removeKeyValuePair = function (index) {
        return setKeyValuePairs(keyValuePairs.filter(function (_, i) { return i !== index; }));
    };
    var resetForm = (0, react_1.useCallback)(function () {
        setMetaKey("");
        setDescription("");
        setKeyValuePairs([{ key: "", value: "", isExisting: false, isUsed: false }]);
        setIsDuplicate(false);
    }, [modalMode]);
    (0, react_1.useEffect)(function () {
        if (isShown) {
            if (modalMode === "edit" && existingMetadata) {
                ApiManager_1.default.getSingleMetadata(existingMetadata.id)
                    .then(function (data) {
                    setMetaKey(data.meta_key || "");
                    setDescription(data.description || "");
                    var keyValuePairsData = data.key_value_pairs;
                    var keyUsage = data.key_usage || {};
                    setKeyValuePairs(Object.entries(keyValuePairsData).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return ({
                            key: key,
                            value: value,
                            isExisting: true,
                            isUsed: keyUsage[key] && keyUsage[key].length > 0,
                            usedInSlides: keyUsage[key] || [],
                        });
                    }));
                })
                    .catch(function (error) {
                    logger.error("Error parsing existing key-value pairs:", error);
                    resetForm();
                    setIsDuplicate(false);
                });
            }
            else if (modalMode === "new") {
                var fetchMetadataKeys = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, keys, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, ApiManager_1.default.getMetadata()];
                            case 1:
                                response = _a.sent();
                                keys = response.map(function (item) { return item.meta_key; });
                                setAllMetadataKeys(keys);
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _a.sent();
                                logger.error("Error fetching metadata keys:", error_1);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                fetchMetadataKeys();
                resetForm();
            }
        }
    }, [isShown, modalMode, existingMetadata, resetForm]);
    var handleSave = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var filteredKeyValuePairs, keyValuePairsObject, metadataData, error_2, errorObj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    filteredKeyValuePairs = keyValuePairs.filter(function (pair) { return pair.key.trim() !== "" || pair.value.trim() !== ""; });
                    keyValuePairsObject = filteredKeyValuePairs.reduce(function (acc, _a) {
                        var key = _a.key, value = _a.value;
                        acc[key] = value;
                        return acc;
                    }, {});
                    metadataData = {
                        meta_key: metaKey.trim(),
                        description: description,
                        key_value_pairs: keyValuePairsObject,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!(modalMode === "new")) return [3 /*break*/, 3];
                    return [4 /*yield*/, ApiManager_1.default.createMetadata(metadataData)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!(modalMode === "edit" && existingMetadata)) return [3 /*break*/, 5];
                    return [4 /*yield*/, ApiManager_1.default.updateMetadata(Number(existingMetadata.id), metadataData)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    handleClose();
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    errorObj = new Error(error_2.message);
                    logger.error(errorObj.message, errorObj);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        toggle();
        resetForm();
    };
    var groupSlidesByPresentation = function (slides) {
        var groups = {};
        slides.forEach(function (slide) {
            var key = "".concat(slide.type, ":").concat(slide.presentation_title);
            if (!groups[key]) {
                groups[key] = { title: slide.presentation_title, type: slide.type, slides: [] };
            }
            groups[key].slides.push(slide);
        });
        return Object.values(groups);
    };
    var filterAllowedMetaKeyCharacters = function (event) {
        var allowedKeys = /[a-z0-9\-_]/;
        if (!event.key.match(allowedKeys)) {
            event.preventDefault();
        }
    };
    var body = (react_1.default.createElement("div", { className: Metadata_module_css_1.default.body, "data-cy": "metadataModal" },
        react_1.default.createElement("div", { className: Metadata_module_css_1.default["form-group"] },
            react_1.default.createElement("div", { className: Metadata_module_css_1.default["form-group-item"] },
                react_1.default.createElement("label", { htmlFor: "meta-key" }, t("Metadata")),
                react_1.default.createElement("div", { className: Metadata_module_css_1.default["input-container"] },
                    react_1.default.createElement(q_play_components_1.Input, { type: "text", id: "meta-key", name: "meta-key", value: metaKey, onKeyDown: filterAllowedMetaKeyCharacters, onChange: handleMetaKeyChange, style: {
                            cursor: modalMode === "edit" ? "default" : "text",
                            backgroundColor: modalMode === "edit" ? "#e1e1e1" : "none",
                            borderColor: isDuplicate ? "var(--error-color)" : "#D2D2D2",
                            maxWidth: "35%",
                            flex: 1,
                            borderRadius: "4px"
                        }, readOnly: modalMode === "edit", dataCy: "metadataMetaKeyInput" }),
                    isDuplicate && (react_1.default.createElement("span", { style: { color: "var(--error-color)" } }, t("This metadata already exists"))))),
            react_1.default.createElement("div", { className: Metadata_module_css_1.default["form-group-item"], style: { marginTop: "10px", marginBottom: "10px" } },
                react_1.default.createElement("label", { htmlFor: "description" }, t("Description")),
                react_1.default.createElement("div", { className: Metadata_module_css_1.default["input-container"] },
                    react_1.default.createElement(q_play_components_1.Input, { type: "text", id: "description", name: "description", value: description, onChange: handleDescriptionChange, style: {
                            maxWidth: "35%",
                            borderRadius: "4px",
                            flex: 1,
                            borderColor: isTooLong ? "var(--error-color)" : "#D2D2D2",
                        }, dataCy: "metadataDescriptionInput" }),
                    isTooLong && (react_1.default.createElement("span", { style: { color: "var(--error-color)" } }, t("Description must be 250 characters or less")))))),
        react_1.default.createElement("div", { style: { marginTop: "10px", marginBottom: "10px" } },
            react_1.default.createElement("span", null,
                t("Elements"),
                ":")),
        react_1.default.createElement("div", { className: "".concat(Metadata_module_css_1.default["metadata-key-value-container"], " ns-font-family-bold"), style: { color: "var(--info-color)" } },
            react_1.default.createElement("div", { className: Metadata_module_css_1.default["key-value-text-container"], style: { display: "flex", justifyContent: "end" } },
                react_1.default.createElement("span", { style: { width: "43%" } }, t("Name")),
                react_1.default.createElement("span", { style: { width: "32%" } }, t("Value")))),
        react_1.default.createElement("div", { className: Metadata_module_css_1.default["scrollable-metadata-container"] }, keyValuePairs.map(function (pair, index) {
            var groupedPresentations = pair.isUsed && pair.usedInSlides && pair.usedInSlides.length > 0
                ? groupSlidesByPresentation(pair.usedInSlides)
                : [];
            var tooltipContent = pair.isUsed && groupedPresentations.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, t("Cannot remove the element because it's used on the following resources")),
                groupedPresentations.map(function (presentation, idx) { return (react_1.default.createElement("div", { key: idx, style: { marginBottom: "10px" } },
                    react_1.default.createElement("p", { style: { fontWeight: "bold", margin: "5px 0" } },
                        presentation.type ? t(presentation.type.toLocaleLowerCase()) : "",
                        ": ",
                        presentation.title),
                    react_1.default.createElement("ul", { style: { margin: 0, paddingLeft: "1.5em" } }, presentation.slides.map(function (slide, slideIdx) { return (react_1.default.createElement("li", { key: slideIdx },
                        t("Slide"),
                        ": ",
                        slide.slide_title)); })))); }))) : ("");
            return (react_1.default.createElement("div", { key: index, className: Metadata_module_css_1.default["metadata-pair"], "data-cy": "metadataPair" },
                react_1.default.createElement(Tooltip_1.default, { title: isInvalidKeyPairFunction(pair) ? t("The name must not be empty") : "", placement: "left", open: isInvalidKeyPairFunction(pair), disableHoverListener: true, disableFocusListener: true, disableTouchListener: true, arrow: true, PopperProps: {
                        sx: {
                            ".MuiTooltip-arrow": {
                                color: "var(--secondary-color)",
                            },
                            ".MuiTooltip-tooltip": {
                                backgroundColor: "var(--secondary-color)",
                                color: "var(--error-color)",
                                borderRadius: "7px",
                                padding: "12px"
                            },
                        },
                    } },
                    react_1.default.createElement("span", { style: { display: "flex", width: "100%", marginRight: "4px" } },
                        react_1.default.createElement(q_play_components_1.Input, { type: "text", value: pair.key, onKeyDown: filterAllowedMetaKeyCharacters, onChange: function (e) { return handleKeyValuePairsChange(index, e.target.value, pair.value); }, readOnly: modalMode === "edit" && pair.isExisting, style: {
                                textAlign: "center",
                                borderRadius: "4px",
                                cursor: modalMode === "edit" && pair.isExisting ? "default" : "text",
                                backgroundColor: modalMode === "edit" && pair.isExisting ? "#e1e1e1" : "none",
                                borderColor: isInvalidKeyPairFunction(pair) ? "var(--error-color)" : undefined,
                            }, dataCy: "metadataKeyInput" }))),
                react_1.default.createElement(q_play_components_1.Input, { type: "text", value: pair.value, onChange: function (e) { return handleKeyValuePairsChange(index, pair.key, e.target.value); }, style: { textAlign: "center", borderRadius: "4px" }, dataCy: "metadataValueInput" }),
                react_1.default.createElement(Tooltip_1.default, { title: tooltipContent, placement: "top", arrow: true, PopperProps: {
                        sx: {
                            ".MuiTooltip-arrow": {
                                color: "var(--secondary-color)",
                            },
                            ".MuiTooltip-tooltip": {
                                backgroundColor: "var(--secondary-color)",
                                color: "var(--info-color)",
                                borderRadius: "7px",
                                padding: "12px"
                            },
                        },
                    } },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan, className: Metadata_module_css_1.default["trash-icon"], onClick: function () { return removeKeyValuePair(index); }, style: {
                                pointerEvents: pair.isUsed === false ? "auto" : "none",
                                opacity: pair.isUsed === false ? 1 : 0.5,
                            } })))));
        })),
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                position: "relative",
                marginTop: "45px",
            } },
            react_1.default.createElement(q_play_components_1.Button, { text: t("+"), variant: "primary", onClick: addKeyValuePair, style: { width: "100%", position: "absolute", bottom: 0, fontSize: "20px" }, dataCy: "addKeyValuePairRowButton" }))));
    var footer = (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
        react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), onClick: handleSave, disabled: !metaKey || isDuplicate || isInvalidKeyPair || isTooLong, "data-cy": "saveMetadataButton" })));
    var CustomHeader = (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { fontSize: "20px", color: "var(--info-color)" } },
        react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, modalMode === "edit" ? t("Update metadata") : t("New metadata")),
        react_1.default.createElement("div", { style: { fontFamily: "Geomanist", fontSize: "14px", color: "var(--warning-color)", marginTop: "5px", fontStyle: "italic" } },
            t("Metadata and elements name only allow these characters"),
            ": a-z, 0-9, _, -")));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: handleClose, centered: true, header: CustomHeader, body: body, footer: footer, dialogClassName: Metadata_module_css_1.default["new-metadata-modal"] }));
};
exports.default = MetadataModal;
